module.exports = __webpack_public_path__ + "static/media/relaxmit-5.3b10c8c8.jpg";